import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor() { }

  setToken(token) {
    sessionStorage.setItem('token', token);
  }
  get getToken() {
    return sessionStorage.getItem('token');
  }
}
